import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      PAUSE_FOR_A_LIMITED_PERIOD: "Pause i en begrenset periode",
      FROM_DATE: "Fra dato",
      SELECT_DATE: "Velg dato",
      TO_DATE: "Til dato",
      YOU_WILL_NOT_RECEIVE_ANY_DELIVERY_IN_THIS_PERIOD:
        "Du vil ikke motta noen levering i denne perioden hvis du ikke bestiller individuelle leveranser.",
      REGISTER_PAUSE: "Registrer pause",
      CANCEL: "Avbryt",

      PAUSE_FAILED_ERROR:
        "Noe gikk dessverre galt, ta kontakt med kundetjeneste.",
    },

    se: {
      PAUSE_FOR_A_LIMITED_PERIOD: "Pausa en begränsad tid",
      FROM_DATE: "Från datum",
      SELECT_DATE: "Välj datum",
      TO_DATE: "Till datum",
      YOU_WILL_NOT_RECEIVE_ANY_DELIVERY_IN_THIS_PERIOD:
        "Du kommer inte att få någon leverans under denna period om du inte beställer enskilda leveranser.",
      REGISTER_PAUSE: "Registrera paus",
      CANCEL: "Avbryt",

      PAUSE_FAILED_ERROR:
        "Något gick tyvärr fel, vänligen ta kontakt med kundtjänst",
    },

    dk: {
      PAUSE_FOR_A_LIMITED_PERIOD: "Pause i begrænset periode",
      FROM_DATE: "Fra dato",
      SELECT_DATE: "Velg dato",
      TO_DATE: "Til dato",
      YOU_WILL_NOT_RECEIVE_ANY_DELIVERY_IN_THIS_PERIOD:
        "Du modtager ingen levering i denne periode, hvis du ikke bestiller enkeltleverancer.",
      REGISTER_PAUSE: "Registrer pause",
      CANCEL: "Annuler",

      PAUSE_FAILED_ERROR:
        "Något gick tyvärr fel, vänligen ta kontakt med kundtjänst",
    },
  } as const
)[language];
